import router from "@/router";
import axios from "axios";

// API
const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const currentRoute = router.currentRoute?.name;

    if (status === 401) {
      const adminGuestRoutes = ["login"];
      const companyGuestRoutes = ["login-comp", "login-collab"];

      if (
        !adminGuestRoutes.includes(currentRoute) &&
        currentRoute?.startsWith("adm")
      ) {
        router.push({ name: "login" });
      }

      if (
        !companyGuestRoutes.includes(currentRoute) &&
        currentRoute?.startsWith("enter")
      ) {
        router.push({ name: "login-comp" });
      }
    }

    return Promise.reject(error);
  }
);

export { http };
